export enum EmptyStateVariants {
  Screenz = 'Screenz',
  Reseller = 'Reseller',
  SuperAdmin = 'SuperAdmin',
  Content = 'Content',
  Playlists = 'Playlists',
  Clients = 'Clients',
}
